import { Injectable } from '@angular/core';
import moment from 'moment';

import 'moment/locale/de';

import { UserService } from '../user-service/user.service';

export const dateFormatter = (params: any): string => {
  if (params.value) {
    moment.locale('de');
    return moment(params.value).format('L');
  }
  return '';
};

export const criteriaDateFormatter = (params: any): string => {
  if (params.value) {
    moment.locale('de');
    return moment(params.value, 'DD.MM.YYYY').format('L');
  }
  return '';
};

export const getDateAsFormattedString = (dateValue: any): string => {
  if (dateValue) {
    moment.locale('de');
    return moment(dateValue).format('L');
  }
  return '';
};

@Injectable({
  providedIn: 'root',
})
export class AGGridFormatterService {
  public currencyFormatterDefault(userService: UserService) {
    return params =>
      new Intl.NumberFormat(userService.userLanguage, {
        style: 'currency',
        currency: 'EUR',
      }).format(params.value);
  }

  /**
   * For Tables and pivotTables.
   * On pivotTables:
   * If Value == undefined an empty string will returned.
   * This is usefull when the values appears in a group and the aggregation is not assigent to the values.
   * E.g.: Go to ReportingView. On RowGroupsArea assign only 'Intern/Extern'. On ValuesArea assign and remove 'sum(Prognosekosten)' to see the behavior.
   * @param tokenStorageService
   */
  public currencyFormatter(userService: UserService) {
    return params =>
      params.value === undefined
        ? ''
        : new Intl.NumberFormat(userService.userLanguage, {
            style: 'currency',
            currency: 'EUR',
          }).format(params.value);
  }

  public percentageFormatter(us: UserService): (params: any) => string {
    const decimalSeparator = us.userLanguage.startsWith('en') ? '.' : ',';
    return params => (params.value == null ? undefined : `${params.value.toString().replace('.', decimalSeparator)} %`);
  }

  public dateFormatter(params: any): string {
    return dateFormatter(params);
  }

  public cellClassCurrencyType(params: any): string {
    return params.data.currency === 'USD' ? 'currencyFormatUSD' : 'currencyFormat';
  }
}
